// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/company.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ImageResponse } from "./image_pb";
import { file_api_proto_v1_image } from "./image_pb";
import type { GetStaffResponse } from "./staff_pb";
import { file_api_proto_v1_staff } from "./staff_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/company.proto.
 */
export const file_api_proto_v1_company: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_image, file_api_proto_v1_staff, file_google_protobuf_wrappers]);

/**
 * Company entity and related messages
 *
 * @generated from message api_proto.v1.CreateCompanyRequest
 */
export type CreateCompanyRequest = Message<"api_proto.v1.CreateCompanyRequest"> & {
  /**
   * @generated from field: string company_name = 1;
   */
  companyName: string;

  /**
   * @generated from field: string staff_name = 2;
   */
  staffName: string;

  /**
   * @generated from field: string staff_email = 3;
   */
  staffEmail: string;

  /**
   * 作成と同時に結ぶ契約。plan_typeごとに最大1件。空なら契約を作らない（箱だけの企業）。
   * 旧権限（CompanyPermissionType）はリクエストで受け取らず、サーバが選択プランから導出する
   *
   * @generated from field: repeated api_proto.v1.CreateCompanyContractInput contracts = 5;
   */
  contracts: CreateCompanyContractInput[];
};

/**
 * Describes the message api_proto.v1.CreateCompanyRequest.
 * Use `create(CreateCompanyRequestSchema)` to create a new message.
 */
export const CreateCompanyRequestSchema: GenMessage<CreateCompanyRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 0);

/**
 * 企業作成時に同時に結ぶ契約の指定。契約開始日は当日固定のためフィールドを持たない
 *
 * @generated from message api_proto.v1.CreateCompanyContractInput
 */
export type CreateCompanyContractInput = Message<"api_proto.v1.CreateCompanyContractInput"> & {
  /**
   * ListServicePlansが返すplanのid（ULID）
   *
   * @generated from field: string service_plan_id = 1;
   */
  servicePlanId: string;

  /**
   * 支払いサイクル yearly / monthly（go/models/company_contract.goのBillingCycle定数）
   *
   * @generated from field: string billing_cycle = 2;
   */
  billingCycle: string;

  /**
   * 契約の数量（CreateCompanyContractRequestと同じ規則）。プランが標準の数量を持たない
   * （エンタープライズ）ときは、営業支援はgrant_credits_per_period、業務管理はmax_active_staffs_overrideが必須。
   * 種別違いは入力エラー
   *
   * @generated from field: optional int64 grant_credits_per_period = 3;
   */
  grantCreditsPerPeriod?: bigint;

  /**
   * @generated from field: optional int64 max_active_staffs_override = 4;
   */
  maxActiveStaffsOverride?: bigint;
};

/**
 * Describes the message api_proto.v1.CreateCompanyContractInput.
 * Use `create(CreateCompanyContractInputSchema)` to create a new message.
 */
export const CreateCompanyContractInputSchema: GenMessage<CreateCompanyContractInput> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 1);

/**
 * @generated from message api_proto.v1.GetCompanyResponse
 */
export type GetCompanyResponse = Message<"api_proto.v1.GetCompanyResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated api_proto.v1.GetStaffResponse staffs = 3;
   */
  staffs: GetStaffResponse[];

  /**
   * 企業ロゴ画像（未設定時はnil）
   *
   * @generated from field: optional api_proto.v1.ImageResponse logo = 5;
   */
  logo?: ImageResponse;

  /**
   * 企業社印画像（未設定時はnil）
   *
   * @generated from field: optional api_proto.v1.ImageResponse seal = 6;
   */
  seal?: ImageResponse;

  /**
   * 休止日時（RFC3339）。休止中のとき設定。未休止は空文字。plan-restructure-2026-10 R2
   *
   * @generated from field: string suspended_at = 7;
   */
  suspendedAt: string;
};

/**
 * Describes the message api_proto.v1.GetCompanyResponse.
 * Use `create(GetCompanyResponseSchema)` to create a new message.
 */
export const GetCompanyResponseSchema: GenMessage<GetCompanyResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 2);

/**
 * Company staff management
 *
 * @generated from message api_proto.v1.CreateCompanyStaffRequest
 */
export type CreateCompanyStaffRequest = Message<"api_proto.v1.CreateCompanyStaffRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: string staff_name = 2;
   */
  staffName: string;

  /**
   * @generated from field: string staff_email = 3;
   */
  staffEmail: string;

  /**
   * ハウスケープのサポートアカウントとして作るか（決定125）。座席に数えず、作成直後はログインできない（OFF）。
   * @h-scape.com 以外のメールで true にすると SUPPORT_STAFF_EMAIL_INVALID
   *
   * @generated from field: bool is_support = 4;
   */
  isSupport: boolean;
};

/**
 * Describes the message api_proto.v1.CreateCompanyStaffRequest.
 * Use `create(CreateCompanyStaffRequestSchema)` to create a new message.
 */
export const CreateCompanyStaffRequestSchema: GenMessage<CreateCompanyStaffRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 3);

/**
 * @generated from message api_proto.v1.CreateCompanyStaffResponse
 */
export type CreateCompanyStaffResponse = Message<"api_proto.v1.CreateCompanyStaffResponse"> & {
  /**
   * @generated from field: api_proto.v1.GetStaffResponse staff = 1;
   */
  staff?: GetStaffResponse;
};

/**
 * Describes the message api_proto.v1.CreateCompanyStaffResponse.
 * Use `create(CreateCompanyStaffResponseSchema)` to create a new message.
 */
export const CreateCompanyStaffResponseSchema: GenMessage<CreateCompanyStaffResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 4);

/**
 * @generated from message api_proto.v1.UpdateCompanyStaffRequest
 */
export type UpdateCompanyStaffRequest = Message<"api_proto.v1.UpdateCompanyStaffRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string staff_name = 2;
   */
  staffName: string;

  /**
   * @generated from field: string staff_email = 3;
   */
  staffEmail: string;
};

/**
 * Describes the message api_proto.v1.UpdateCompanyStaffRequest.
 * Use `create(UpdateCompanyStaffRequestSchema)` to create a new message.
 */
export const UpdateCompanyStaffRequestSchema: GenMessage<UpdateCompanyStaffRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 5);

/**
 * @generated from message api_proto.v1.UpdateCompanyStaffResponse
 */
export type UpdateCompanyStaffResponse = Message<"api_proto.v1.UpdateCompanyStaffResponse"> & {
  /**
   * @generated from field: api_proto.v1.GetStaffResponse staff = 1;
   */
  staff?: GetStaffResponse;
};

/**
 * Describes the message api_proto.v1.UpdateCompanyStaffResponse.
 * Use `create(UpdateCompanyStaffResponseSchema)` to create a new message.
 */
export const UpdateCompanyStaffResponseSchema: GenMessage<UpdateCompanyStaffResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 6);

/**
 * @generated from message api_proto.v1.DeleteCompanyStaffRequest
 */
export type DeleteCompanyStaffRequest = Message<"api_proto.v1.DeleteCompanyStaffRequest"> & {
  /**
   * @generated from field: int64 staff_id = 1;
   */
  staffId: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteCompanyStaffRequest.
 * Use `create(DeleteCompanyStaffRequestSchema)` to create a new message.
 */
export const DeleteCompanyStaffRequestSchema: GenMessage<DeleteCompanyStaffRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 7);

/**
 * サポートアカウントのログインをON（期限つき）/OFFにする。対象がサポートアカウントでなければ STAFF_NOT_SUPPORT、
 * 停止済みなら STAFF_ARCHIVED（停止が優先。解除してからONにする）。ONにするたびに期限を上書きする（延長も同じ操作）
 *
 * @generated from message api_proto.v1.SetCompanyStaffSupportAccessRequest
 */
export type SetCompanyStaffSupportAccessRequest = Message<"api_proto.v1.SetCompanyStaffSupportAccessRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: int64 staff_id = 2;
   */
  staffId: bigint;

  /**
   * @generated from field: api_proto.v1.SupportAccessDuration duration = 3;
   */
  duration: SupportAccessDuration;
};

/**
 * Describes the message api_proto.v1.SetCompanyStaffSupportAccessRequest.
 * Use `create(SetCompanyStaffSupportAccessRequestSchema)` to create a new message.
 */
export const SetCompanyStaffSupportAccessRequestSchema: GenMessage<SetCompanyStaffSupportAccessRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 8);

/**
 * @generated from message api_proto.v1.SetCompanyStaffSupportAccessResponse
 */
export type SetCompanyStaffSupportAccessResponse = Message<"api_proto.v1.SetCompanyStaffSupportAccessResponse"> & {
  /**
   * @generated from field: api_proto.v1.GetStaffResponse staff = 1;
   */
  staff?: GetStaffResponse;
};

/**
 * Describes the message api_proto.v1.SetCompanyStaffSupportAccessResponse.
 * Use `create(SetCompanyStaffSupportAccessResponseSchema)` to create a new message.
 */
export const SetCompanyStaffSupportAccessResponseSchema: GenMessage<SetCompanyStaffSupportAccessResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 9);

/**
 * 引き継ぎ対象の件数（テーブルごと）。key はサーバー側の列定義の安定キー、label はその表示名。
 * 付け替える列の定義はサーバー（go/repository）だけが持ち、フロントは返された一覧をそのまま出す。
 *
 * @generated from message api_proto.v1.CompanyStaffHandoverCount
 */
export type CompanyStaffHandoverCount = Message<"api_proto.v1.CompanyStaffHandoverCount"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: int64 count = 3;
   */
  count: bigint;
};

/**
 * Describes the message api_proto.v1.CompanyStaffHandoverCount.
 * Use `create(CompanyStaffHandoverCountSchema)` to create a new message.
 */
export const CompanyStaffHandoverCountSchema: GenMessage<CompanyStaffHandoverCount> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 10);

/**
 * 引き継ぎの対象件数を副作用なしで返す（実行前の確認用）
 *
 * @generated from message api_proto.v1.PreviewCompanyStaffHandoverRequest
 */
export type PreviewCompanyStaffHandoverRequest = Message<"api_proto.v1.PreviewCompanyStaffHandoverRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: int64 from_staff_id = 2;
   */
  fromStaffId: bigint;
};

/**
 * Describes the message api_proto.v1.PreviewCompanyStaffHandoverRequest.
 * Use `create(PreviewCompanyStaffHandoverRequestSchema)` to create a new message.
 */
export const PreviewCompanyStaffHandoverRequestSchema: GenMessage<PreviewCompanyStaffHandoverRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 11);

/**
 * @generated from message api_proto.v1.PreviewCompanyStaffHandoverResponse
 */
export type PreviewCompanyStaffHandoverResponse = Message<"api_proto.v1.PreviewCompanyStaffHandoverResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CompanyStaffHandoverCount counts = 1;
   */
  counts: CompanyStaffHandoverCount[];
};

/**
 * Describes the message api_proto.v1.PreviewCompanyStaffHandoverResponse.
 * Use `create(PreviewCompanyStaffHandoverResponseSchema)` to create a new message.
 */
export const PreviewCompanyStaffHandoverResponseSchema: GenMessage<PreviewCompanyStaffHandoverResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 12);

/**
 * 担当の一括引き継ぎ。from は停止済み、to は同じ企業の有効なスタッフでなければ FailedPrecondition。
 * 付け替えるのは「担当者」を意味する列だけ（案件・担当者フォーム値・顧客・見積書・請求書・追加契約・
 * Metabase用集計表）。メモの投稿者や作成者などの記録は変えない。
 *
 * @generated from message api_proto.v1.HandoverCompanyStaffAssignmentsRequest
 */
export type HandoverCompanyStaffAssignmentsRequest = Message<"api_proto.v1.HandoverCompanyStaffAssignmentsRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: int64 from_staff_id = 2;
   */
  fromStaffId: bigint;

  /**
   * @generated from field: int64 to_staff_id = 3;
   */
  toStaffId: bigint;
};

/**
 * Describes the message api_proto.v1.HandoverCompanyStaffAssignmentsRequest.
 * Use `create(HandoverCompanyStaffAssignmentsRequestSchema)` to create a new message.
 */
export const HandoverCompanyStaffAssignmentsRequestSchema: GenMessage<HandoverCompanyStaffAssignmentsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 13);

/**
 * @generated from message api_proto.v1.HandoverCompanyStaffAssignmentsResponse
 */
export type HandoverCompanyStaffAssignmentsResponse = Message<"api_proto.v1.HandoverCompanyStaffAssignmentsResponse"> & {
  /**
   * 実際に付け替えた件数（テーブルごと）
   *
   * @generated from field: repeated api_proto.v1.CompanyStaffHandoverCount counts = 1;
   */
  counts: CompanyStaffHandoverCount[];
};

/**
 * Describes the message api_proto.v1.HandoverCompanyStaffAssignmentsResponse.
 * Use `create(HandoverCompanyStaffAssignmentsResponseSchema)` to create a new message.
 */
export const HandoverCompanyStaffAssignmentsResponseSchema: GenMessage<HandoverCompanyStaffAssignmentsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 14);

/**
 * 匿名化。停止済みが前提（有効なスタッフは FailedPrecondition）。氏名を固定文言、メールを無効な
 * アドレス、LINE連携を解除し、本人だけが使う行（保存した検索条件・パスワード設定トークン）を消す。
 * 行そのものは消さない（決定90(n)）。reason は空を拒否する。
 *
 * @generated from message api_proto.v1.AnonymizeCompanyStaffRequest
 */
export type AnonymizeCompanyStaffRequest = Message<"api_proto.v1.AnonymizeCompanyStaffRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: int64 staff_id = 2;
   */
  staffId: bigint;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.AnonymizeCompanyStaffRequest.
 * Use `create(AnonymizeCompanyStaffRequestSchema)` to create a new message.
 */
export const AnonymizeCompanyStaffRequestSchema: GenMessage<AnonymizeCompanyStaffRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 15);

/**
 * @generated from message api_proto.v1.GetCompanyStaffListResponse
 */
export type GetCompanyStaffListResponse = Message<"api_proto.v1.GetCompanyStaffListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.GetStaffResponse staffs = 1;
   */
  staffs: GetStaffResponse[];
};

/**
 * Describes the message api_proto.v1.GetCompanyStaffListResponse.
 * Use `create(GetCompanyStaffListResponseSchema)` to create a new message.
 */
export const GetCompanyStaffListResponseSchema: GenMessage<GetCompanyStaffListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 16);

/**
 * @generated from message api_proto.v1.UpdateCompanyRequest
 */
export type UpdateCompanyRequest = Message<"api_proto.v1.UpdateCompanyRequest"> & {
  /**
   * 会社名はいえサプリ運営（HS）のみ変更可能なため、この RPC では更新されない（サーバー側で無視される）
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.StringValue address = 2;
   */
  address?: string;

  /**
   * @generated from field: google.protobuf.StringValue contact = 3;
   */
  contact?: string;

  /**
   * @generated from field: google.protobuf.StringValue bank_account = 4;
   */
  bankAccount?: string;

  /**
   * @generated from field: google.protobuf.StringValue registration_number = 5;
   */
  registrationNumber?: string;

  /**
   * @generated from field: google.protobuf.Int64Value logo_id = 6;
   */
  logoId?: bigint;

  /**
   * @generated from field: google.protobuf.Int64Value seal_id = 7;
   */
  sealId?: bigint;

  /**
   * 帳票デフォルトの屋号。未指定 = 現状維持（更新系「全項目置換」既定の例外。旧クライアントが
   * 送らないぶんの値を消さないため）。空文字を指定すると NULL に戻り name フォールバックが復活する
   *
   * @generated from field: google.protobuf.StringValue trade_name = 8;
   */
  tradeName?: string;
};

/**
 * Describes the message api_proto.v1.UpdateCompanyRequest.
 * Use `create(UpdateCompanyRequestSchema)` to create a new message.
 */
export const UpdateCompanyRequestSchema: GenMessage<UpdateCompanyRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 17);

/**
 * @generated from message api_proto.v1.UpdateCompanyResponse
 */
export type UpdateCompanyResponse = Message<"api_proto.v1.UpdateCompanyResponse"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string address = 2;
   */
  address: string;

  /**
   * @generated from field: string contact = 3;
   */
  contact: string;

  /**
   * @generated from field: string bank_account = 4;
   */
  bankAccount: string;

  /**
   * @generated from field: string registration_number = 5;
   */
  registrationNumber: string;
};

/**
 * Describes the message api_proto.v1.UpdateCompanyResponse.
 * Use `create(UpdateCompanyResponseSchema)` to create a new message.
 */
export const UpdateCompanyResponseSchema: GenMessage<UpdateCompanyResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 18);

/**
 * @generated from message api_proto.v1.GetOwnCompanyDetailRequest
 */
export type GetOwnCompanyDetailRequest = Message<"api_proto.v1.GetOwnCompanyDetailRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetOwnCompanyDetailRequest.
 * Use `create(GetOwnCompanyDetailRequestSchema)` to create a new message.
 */
export const GetOwnCompanyDetailRequestSchema: GenMessage<GetOwnCompanyDetailRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 19);

/**
 * @generated from message api_proto.v1.GetOwnCompanyDetailResponse
 */
export type GetOwnCompanyDetailResponse = Message<"api_proto.v1.GetOwnCompanyDetailResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 帳票デフォルトの屋号。DB が NULL の場合は name にフォールバックした解決済みの値を返す
   *
   * @generated from field: string trade_name = 10;
   */
  tradeName: string;

  /**
   * @generated from field: google.protobuf.StringValue address = 3;
   */
  address?: string;

  /**
   * @generated from field: google.protobuf.StringValue contact = 4;
   */
  contact?: string;

  /**
   * @generated from field: google.protobuf.StringValue registration_number = 5;
   */
  registrationNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue bank_account = 6;
   */
  bankAccount?: string;

  /**
   * @generated from field: optional api_proto.v1.ImageResponse logo = 7;
   */
  logo?: ImageResponse;

  /**
   * @generated from field: optional api_proto.v1.ImageResponse seal = 8;
   */
  seal?: ImageResponse;

  /**
   * @generated from field: repeated api_proto.v1.GetStaffResponse staffs = 9;
   */
  staffs: GetStaffResponse[];
};

/**
 * Describes the message api_proto.v1.GetOwnCompanyDetailResponse.
 * Use `create(GetOwnCompanyDetailResponseSchema)` to create a new message.
 */
export const GetOwnCompanyDetailResponseSchema: GenMessage<GetOwnCompanyDetailResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 20);

/**
 * @generated from message api_proto.v1.GetStaffsRequest
 */
export type GetStaffsRequest = Message<"api_proto.v1.GetStaffsRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetStaffsRequest.
 * Use `create(GetStaffsRequestSchema)` to create a new message.
 */
export const GetStaffsRequestSchema: GenMessage<GetStaffsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 21);

/**
 * @generated from message api_proto.v1.GetStaffsResponse
 */
export type GetStaffsResponse = Message<"api_proto.v1.GetStaffsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.GetStaffResponse staffs = 3;
   */
  staffs: GetStaffResponse[];
};

/**
 * Describes the message api_proto.v1.GetStaffsResponse.
 * Use `create(GetStaffsResponseSchema)` to create a new message.
 */
export const GetStaffsResponseSchema: GenMessage<GetStaffsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company, 22);

/**
 * サポートアカウントのログインできる期間の選択肢（決定125）。期限の日時はサーバーが現在時刻から計算する
 * （クライアントに日時を送らせると、遠い未来を入れて実質つけっぱなしにできるため）
 *
 * @generated from enum api_proto.v1.SupportAccessDuration
 */
export enum SupportAccessDuration {
  /**
   * @generated from enum value: SUPPORT_ACCESS_DURATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * OFFに戻す（期限を消す）
   *
   * @generated from enum value: SUPPORT_ACCESS_DURATION_OFF = 1;
   */
  OFF = 1,

  /**
   * いまから1時間
   *
   * @generated from enum value: SUPPORT_ACCESS_DURATION_ONE_HOUR = 2;
   */
  ONE_HOUR = 2,

  /**
   * 今日中（当日23:59:59 JSTまで）
   *
   * @generated from enum value: SUPPORT_ACCESS_DURATION_END_OF_TODAY = 3;
   */
  END_OF_TODAY = 3,

  /**
   * いまから24時間
   *
   * @generated from enum value: SUPPORT_ACCESS_DURATION_TWENTY_FOUR_HOURS = 4;
   */
  TWENTY_FOUR_HOURS = 4,
}

/**
 * Describes the enum api_proto.v1.SupportAccessDuration.
 */
export const SupportAccessDurationSchema: GenEnum<SupportAccessDuration> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_company, 0);

/**
 * プロダクト種別（company_product_typesマスタのseed値。RPCでは使わない。
 * 旧CompanyContractRenewal（プロダクト別の契約更新月）は旧テーブルのDROPに伴い削除した）
 *
 * @generated from enum api_proto.v1.CompanyProductType
 */
export enum CompanyProductType {
  /**
   * @generated from enum value: COMPANY_PRODUCT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * いえサプリ
   *
   * @generated from enum value: COMPANY_PRODUCT_TYPE_IESAPURI = 1;
   */
  IESAPURI = 1,

  /**
   * AIカラー
   *
   * @generated from enum value: COMPANY_PRODUCT_TYPE_AI_COLOR = 2;
   */
  AI_COLOR = 2,

  /**
   * やねプロ
   *
   * @generated from enum value: COMPANY_PRODUCT_TYPE_YANE_PRO = 3;
   */
  YANE_PRO = 3,
}

/**
 * Describes the enum api_proto.v1.CompanyProductType.
 */
export const CompanyProductTypeSchema: GenEnum<CompanyProductType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_company, 1);

